import Geocode from "react-geocode"

Geocode.setApiKey("AIzaSyD_qeDzdkf2zSLwX8g5zll7tjzU7lmgB5E")

const GeocodeLocations = async locations => {
  let _locations =
    locations.sort(function (a, b) {
      return (
        new Date(b.carrier_timestamp_at) -
        new Date(a.carrier_timestamp_at)
      )
    })
  _locations = _locations.filter(x => x.latitude && x.latitude)
  _locations = [_locations[0]]

  const geocodePromises = _locations.map(async location => {
    if (!location.latitude || location.latitude === 0.0) {
      const address =
        location.occured_at +
        " " +
        location.city +
        "," +
        location.state_province +
        " " +
        location.country_code +
        " " +
        location.postal_code

      const addressGeocode = await Geocode.fromAddress(address)

      if ((addressGeocode.status = "Ok")) {
        location.latitude = addressGeocode.results[0].geometry.location.lat

        location.longitude = addressGeocode.results[0].geometry.location.lng
      }
    }

    return location
  })

  try {
    const codedLocations = await Promise.all(geocodePromises)
  } catch (error) {
    console.error(`Geocoding generated error: ${error}`)
  }

  return _locations
}

export default GeocodeLocations
